import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {BillingProductTypes, BillingTypes} from "../constants/ManualEntryRecordsActionConstants";
import {Checkbox, Icon} from "semantic-ui-react";
import {
    getFormOptions,
    toggleDeleteWarningForRecord,
    toggleEditRecordsModal
} from "../actions/ManualEntryRecordsActions";
import _ from "lodash";
import COUNTRIES from "../../../common/resources/countries.json";

export class ManualEntryRecordsListRow extends React.Component {

    state = {
        isHovered: false,
    }

    static propTypes = {
        billingRecord: PropTypes.object,
        organization: PropTypes.string,
        tenant: PropTypes.string,
        countryCode: PropTypes.string,
        pricingScheme: PropTypes.string,
        billingType: PropTypes.string,
        billingProduct: PropTypes.string,
        billingPeriod: PropTypes.string,
        itemDescription: PropTypes.string,
        itemQuantity: PropTypes.number,
        itemUnitPrice: PropTypes.number,
        itemTotal: PropTypes.number,
    }

    handleEditBillingRecord = () => {
        if (Object.keys(this.props.orgTenantCountryObject).length === 0) {
            this.props.populateFormOptions();
        }
        this.props.toggleEditBillingRecordModal(this.props.billingRecord);
    }

    handleDeleteBillingRecord = () => {
        this.props.toggleDeleteBillingRecordModal(this.props.billingRecord.id)
    }

    get recordsCheckbox() {
        return (
            <td>
                <Checkbox disabled />
            </td>
        );
    }

    get recordsEditDelete() {
        return (
            <td
                onMouseEnter={() => this.setState({isHovered: true})}
                onMouseLeave={() => this.setState({isHovered: false})}
            >
                {this.state.isHovered && this.props.isBillingAdmin
                    ? (
                        <div className={"edit-records"}>
                            <Icon link
                                  name="pencil alternate"
                                  size="large"
                                  onClick={this.handleEditBillingRecord}
                            />
                            <Icon link
                                  name="trash alternate outline" color="red"
                                  size="large"
                                  onClick={this.handleDeleteBillingRecord}
                            />
                        </div>
                    )
                    : null
                }
            </td>
        );
    }

    get countryCode() {
        const { countryCode } = this.props;
        if (countryCode !== null) {
            return (
                <td>
                    {countryCode +  ' - ' + _.result(_.find(COUNTRIES, {'value': countryCode}), 'label')}
                </td>
            )
        } else {
            return (
                <td>{countryCode}</td>
            )
        }
    }

    get billingType() {
        const { billingType } = this.props;

        return (
            <td>{BillingTypes[billingType]}</td>
        );
    }

    get billingProduct() {
        const { billingType, billingProduct } = this.props;
        const currentBillingProduct = BillingProductTypes[billingType]

        return (
            <td>{currentBillingProduct[billingProduct]}</td>
        );
    }

    render() {

        return(
            <tr>
                {this.recordsCheckbox}
                {this.recordsEditDelete}
                <td>{this.props.organization}</td>
                <td>{this.props.itemDescription}</td>
                <td>{this.props.tenant}</td>
                {this.countryCode}
                {this.billingType}
                {this.billingProduct}
                <td>{this.props.itemQuantity}</td>
                <td>{"USD "}{this.props.itemUnitPrice}</td>
                <td>{"USD "}{this.props.itemTotal}</td>
            </tr>
        )
    }
}

const mapStateToProps = (state) => ({
    orgTenantCountryObject: state.billing.addEditBillingRecords.orgTenantCountryObject,
    isBillingAdmin: state.marvel.user.access.accessLevel.isBillingAdmin,
});

const mapDispatchToProps = dispatch => ({
    populateFormOptions: () => { dispatch(getFormOptions()) },
    toggleEditBillingRecordModal: (editRecordsObject) => { dispatch(toggleEditRecordsModal(editRecordsObject)) },
    toggleDeleteBillingRecordModal: (recordID) => { dispatch(toggleDeleteWarningForRecord(recordID)) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ManualEntryRecordsListRow)
